var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C8.268 30 2 23.73 2 16C2 8.27 8.268 2 16 2C23.732 2 30 8.27 30 16C30 23.73 23.732 30 16 30ZM16 0C7.163 0 0 7.16 0 16C0 24.84 7.163 32 16 32C24.837 32 32 24.84 32 16C32 7.16 24.837 0 16 0ZM21.7173 10.2798C21.3233 9.8898 20.6863 9.8898 20.2923 10.2798L15.9943 14.5798L11.7583 10.3398C11.3673 9.9498 10.7333 9.9498 10.3443 10.3398C9.95328 10.7298 9.95328 11.3698 10.3443 11.7598L14.5803 15.9898L10.3143 20.2598C9.92128 20.6498 9.92128 21.2898 10.3143 21.6898C10.7083 22.0798 11.3463 22.0798 11.7403 21.6898L16.0063 17.4198L20.2423 21.6598C20.6333 22.0498 21.2673 22.0498 21.6573 21.6598C22.0483 21.2698 22.0483 20.6298 21.6573 20.2398L17.4203 16.0098L21.7173 11.7098C22.1103 11.3098 22.1103 10.6798 21.7173 10.2798Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePreviewIcon);
export default __webpack_public_path__ + "static/media/ClosePreviewIcon.6b2fe2f7d651be93dba4cb1d37e922ea.svg";
export { ForwardRef as ReactComponent };